export default "__VITE_ASSET__DBfhk1Yd__"